
import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/auth'
import my from '../utils/my.js'
import {baseUrl,debugMode} from '../api/env.js'

// 创建axios实例
const service = axios.create({
  //baseURL: process.env.BASE_API, // api 的 base_url
  baseURL:baseUrl,
  timeout: 120000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['user-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200&&res.code!==20000) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 400) {
//      MessageBox.confirm(
//        '你已被登出，可以取消继续留在该页面，或者重新登录',
//        '确定登出',
//        {
//          confirmButtonText: '重新登录',
//          cancelButtonText: '取消',
//          type: 'warning'
//        }
//      ).then(() => {
//        store.dispatch('FedLogOut').then(() => {
//          location.reload() // 为了重新实例化vue-router对象 避免bug
//        })
//      })
      }
     // return Promise.reject(res)
     return response;
    } else {
      return response;
    }
  },
  error => {
    console.log('err' + error) // for debug
//  Message({
//    message: error=='Error: Network Error'?'服务网络出错':error.msg,
//    type: 'error',
//    duration: 5 * 1000
//  })
    return Promise.reject(error)
  }
)
function http_get(uri,data){
	  my.log("get->"+uri+"   "+(data?JSON.stringify(data):''))
  	return service.get(uri,{params:data});
 }
function http_post(uri,data){
	my.log("post->"+uri+"   "+(data?JSON.stringify(data):''))
	var params = new URLSearchParams();
	for(var p in data){
		params.append(p, data[p]);
	}
  	return service.post(uri,params);
  }

function http_post_file(uri,formData){
	let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
		return service.post(uri,formData,config);

}

function form_post(uri,data){
	my.log("post->"+uri+"   "+(data?JSON.stringify(data):''))
	let config = {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
		var params = new URLSearchParams();
		for(var p in data){
			params.append(p, data[p]);
		}
  	return service.post(uri,params,config);
  }

export {
http_post,
http_get,
http_post_file,
form_post
}


